var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOrderSecondCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_orderSecondCard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_orderSecondCard"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,14 L19,6 C19,4.9 18.1,4 17,4 L3,4 C1.9,4 1,4.9 1,6 L1,14 C1,15.1 1.9,16 3,16 L17,16 C18.1,16 19,15.1 19,14 Z M17,14 L3,14 L3,6 L17,6 L17,14 Z M10,7 C8.34,7 7,8.34 7,10 C7,11.66 8.34,13 10,13 C11.66,13 13,11.66 13,10 C13,8.34 11.66,7 10,7 Z M23,7 L23,18 C23,19.1 22.1,20 21,20 L4,20 C4,19 4,19.1 4,18 L21,18 L21,7 C22.1,7 22,7 23,7 Z",
    id: "Shape",
    fill: "#05315F",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOrderSecondCard);
export default __webpack_public_path__ + "static/media/ic_orderSecondCard.a4b2287adc8217951e0ef1ae3ca5434d.svg";
export { ForwardRef as ReactComponent };